import React__default, { useRef, useState } from 'react';
import { Icon, Tooltip, Text, Box } from '@shopify/polaris';
import classNames from 'classnames';
import { useIsomorphicLayoutEffect } from '@shopify/react-hooks';
import styles from './Item.scss.mjs';

function Item({
  id,
  content,
  accessibilityLabel,
  icon,
  suffix,
  active = false,
  disabled = false,
  disabledBackground = true,
  current = false,
  prefix,
  interactive = false,
  onAction,
  truncate = false
}) {
  const itemClassNames = classNames(styles.Item, {
    [styles.active]: active,
    [styles.disabled]: disabled,
    [styles.disabledBackground]: disabled && disabledBackground,
    [styles.current]: current,
    [styles.interactive]: interactive
  });
  const prefixMarkup = getPrefix({
    icon,
    prefix
  });
  const suffixMarkup = suffix ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.Suffix
  }, suffix) : null;
  const fitContent = truncate ? /*#__PURE__*/React__default.createElement(TruncateText, null, content) : content;
  return /*#__PURE__*/React__default.createElement("li", {
    id: id,
    className: itemClassNames,
    "aria-current": current
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: styles.Action,
    disabled: disabled,
    "aria-label": accessibilityLabel,
    onClick: onAction,
    "aria-expanded": suffix ? false : undefined
  }, prefixMarkup, /*#__PURE__*/React__default.createElement("span", {
    className: styles.Content
  }, fitContent), suffixMarkup));
}
function getPrefix({
  icon,
  prefix
}) {
  if (prefix) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.Prefix
    }, prefix);
  }
  if (icon) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.IconPrefix
    }, /*#__PURE__*/React__default.createElement(Icon, {
      source: icon
    }));
  }
  return null;
}
// TODO: extract this to a shared component in Polaris.
// Tracked in this issue: https://github.com/Shopify/online-store-ui/issues/4355
function TruncateText({
  children
}) {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  useIsomorphicLayoutEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > textRef.current.offsetWidth);
    }
  }, [children]);
  const text = /*#__PURE__*/React__default.createElement(Text, {
    as: "span",
    truncate: true
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    ref: textRef
  }, children));
  return isOverflowing ? /*#__PURE__*/React__default.createElement(Tooltip, {
    zIndexOverride: 520,
    preferredPosition: "above",
    hoverDelay: 1000,
    content: children
  }, /*#__PURE__*/React__default.createElement(Text, {
    as: "span",
    truncate: true
  }, children)) : text;
}

export { Item, TruncateText };
